import { initializeApp } from "firebase/app";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_apiKey,
  authDomain: process.env.REACT_APP_FIREBASE_authDomain,
  projectId: process.env.REACT_APP_FIREBASE_projectId,
  storageBucket: process.env.REACT_APP_FIREBASE_storageBucket,
  messagingSenderId: process.env.REACT_APP_FIREBASE_messagingSenderId,
  appId: process.env.REACT_APP_FIREBASE_appId,
  measurementId: process.env.REACT_APP_FIREBASE_measurementId,
  databaseURL: process.env.REACT_APP_FIREBASE_databaseURL,
};

const app = initializeApp(firebaseConfig);

// App Check must init before Firestore/RTDB are used.
// Debug token must be set before initializeAppCheck.
// Never ship debug mode in production builds.
const isNonProd = process.env.NODE_ENV !== "production";
const appCheckDebugToken = process.env.REACT_APP_FIREBASE_appCheckDebugToken;
const isLocalhost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

if (isNonProd && typeof window !== "undefined") {
  if (appCheckDebugToken) {
    // "true" => SDK generates UUID (register it in Console). Or set a fixed registered UUID.
    window.FIREBASE_APPCHECK_DEBUG_TOKEN =
      appCheckDebugToken === "true" ? true : appCheckDebugToken;
  } else if (isLocalhost) {
    // reCAPTCHA must not allow localhost; debug provider is required for local.
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
}

const recaptchaSiteKey = process.env.REACT_APP_FIREBASE_recaptchaSiteKey;
let appCheck = null;

if (recaptchaSiteKey) {
  // Fraud Defense / reCAPTCHA Enterprise key (same key registered in App Check).
  // Debug token still needs initializeAppCheck; attestation is bypassed locally.
  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(recaptchaSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
} else if (process.env.NODE_ENV !== "test") {
  console.warn(
    "App Check skipped: set REACT_APP_FIREBASE_recaptchaSiteKey to your reCAPTCHA Enterprise key."
  );
}

const db = getFirestore(app);
const dbRealtime = getDatabase(app);

export { app, appCheck, db, dbRealtime };
